import Utility from '../../../util/utilityfunctions';
import normalizeAssertions from './normalizeAssertions';

const mapAccount = (account) => ({
	...account,
	assertions: normalizeAssertions(account.assertions),
	pspIndexes: Utility.sortListData(account.pspIndexes, 'pspIndexTitle')
});

export default (accounts) => {
	return Utility.sortListData(accounts, 'accountName')?.map(mapAccount);
};
